import { MockFactory } from '@tino-frontend/mocks'
import { SnoozeSimulationResponse } from '@types'

export const SnoozeSimulationMock = new MockFactory<SnoozeSimulationResponse>({
  future_debt_value: 1,
  interest_percentage: 2,
  interest_value: 3,
  minimum_payment: 4,
  financing_id: 'financingId_1',
})
